import { useSelector } from 'react-redux';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getAppInstance } from '/@/store/session/selectors';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const Terms = () => {
    const appInstance = useSelector(getAppInstance);
    return (
        <div>
            <Title color='primary' bolder theme={settings.app.theme} className={styles.title}>
                {_('Términos y condiciones')}
            </Title>
            <Title color='light' size='md' className={styles.terms}>
                {_(appInstance.termsAndConditions)}
            </Title>
        </div>
    );
};

export default Terms;
